'use client'

import { useParams } from 'next/navigation'
import { ReactNode } from 'react'
import { LocalizedLink } from '@/components/LocalizedLink'
import getUrlPrefix from '@/utils/getUrlPrefix'
import { InternalLinkRecord } from '@/graphql/types'
import { InternalLinkFragment } from '@/components/DatoLink/InternalLink.generated'

type InternalLinkProps = {
	fragment: InternalLinkFragment
	children: ReactNode
	id?: string
	className?: string
	style?: { [key: string]: string | number }
	inactive?: boolean
	params?: string
	onClick?: React.MouseEventHandler<HTMLAnchorElement>
	locale?: string
}

export default function InternalLink({
	fragment,
	children,
	className,
	style,
	inactive = false,
	params,
	locale,
	onClick,
}: InternalLinkProps) {
	const { lang } = useParams()

	return (
		<LocalizedLink
			locale={locale || lang}
			href={
				inactive
					? undefined
					: `${getUrlPrefix(fragment as InternalLinkRecord)}${
							params ? params : ''
						}`
			}
			className={className || ''}
			style={style}
			key={
				inactive
					? undefined
					: fragment.id + String(Math.round(Math.random() * 10000))
			}
			onClick={onClick}
		>
			{children}
		</LocalizedLink>
	)
}
